import React from 'react';
import { Link } from 'react-router-dom';

const TeacherPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <section className="rounded-2xl p-8 sm:p-12 text-white bg-gradient-to-br from-amber-500 via-orange-500 to-red-500 shadow-xl">
          <h1 className="text-3xl sm:text-5xl font-extrabold">Teach & Earn with Confidence</h1>
          <p className="mt-4 text-lg text-orange-50">
            Build your student base, create exams, and grow income with platform support.
          </p>
          <ul className="mt-6 space-y-2 text-base">
            <li>- Create profile</li>
            <li>- Get leads</li>
            <li>- Conduct classes</li>
            <li>- Create exams</li>
            <li>- Earn from enrollments</li>
            <li>- Subscription guarantee</li>
          </ul>
          <div className="mt-8 flex gap-3">
            <Link
              to="/register"
              className="inline-flex items-center rounded-md bg-white px-5 py-3 text-sm font-semibold text-slate-900 hover:bg-slate-100"
            >
              Become a Teacher
            </Link>
            <Link
              to="/teacher/subscription-plans"
              className="inline-flex items-center rounded-md bg-slate-900/30 px-5 py-3 text-sm font-semibold text-white hover:bg-slate-900/40"
            >
              View Teacher Plans
            </Link>
          </div>
        </section>
      </main>
    </div>
  );
};

export default TeacherPage;
